import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dms-money",
  "use": "icon-dms-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dms-money\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 64h768a64 64 0 0 1 64 64v770.112a64 64 0 0 1-94.4 56.32l-323.2-174.336a64 64 0 0 0-60.8 0l-323.2 174.336A64 64 0 0 1 64 898.112V128a64 64 0 0 1 64-64z m451.904 331.2L744.96 233.6a24.896 24.896 0 0 0-1.536-35.072 24.896 24.896 0 0 0-35.008 1.536L514.304 390.144l-194.112-190.08a24.896 24.896 0 0 0-35.008-1.6 24.896 24.896 0 0 0-1.536 35.072l165.056 161.664H326.912a24.832 24.832 0 0 0 0 49.6h162.56v52.288H393.088a24.768 24.768 0 0 0 0 49.6h96.384v123.712a24.768 24.768 0 1 0 49.6 0V546.688H635.52a24.768 24.768 0 0 0 0-49.6H539.072V444.8h162.56a24.832 24.832 0 0 0 0-49.6H579.904z\" fill=\"#515151\" p-id=\"3550\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dms-money.svg
// module id = LW2B
// module chunks = 158